var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("span", [
        _vm._v(_vm._s(_vm.secondsToHmsNumber(_vm.remainingTime)) + "/"),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "time-limit" }, [
        _vm._v(_vm._s(_vm.timeLimit) + "min"),
      ]),
      _vm._v(" "),
      _c("ProgressRotate", {
        attrs: {
          score: 40,
          value: (_vm.remainingTime * 100) / (_vm.timeLimit * 60),
          color: "#2699fb",
          width: 15,
          size: 30,
          rotate: -90,
          showLable: false,
          mirror: true,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }